import { QueryParams } from "PFTypes/query_params";

export const accessRequestsKeys = {
  all: () => ["accessRequests"],
  list: (params: Pick<QueryParams, "page" | "perPage"> = {}) => [...accessRequestsKeys.all(), "list", params]
};
